exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ticket-details{display:flex;flex-direction:column;overflow:auto;height:calc(100vh - 140px);@media (min-width:640px){height:calc(100vh - 63px)}}", ""]);

// exports
